











































import Vue from "vue";
import FilterBar from "@/components/Table/FilterBar.vue";
import { store } from "@/store/store";

export default Vue.extend({
  name: "UserFilter",
  components: { FilterBar },
  props: {
    should_be_displayed: {
      type: Boolean,
      default: false
    },
    filters: {
      type: Object
    }
  },
  data() {
    return {
      agences: store.getters.AGENCE_ALL_ID.map((agence) => store.getters.AGENCE_BY_ID[agence]),
      roles: store.getters.ROLE_ALL_ID.map((role) => store.getters.ROLE_BY_ID[role]),
      mail: this.filters.mail,
      role: this.filters.role,
      agence: this.filters.agence
    };
  },
  methods: {
    close(e: MouseEvent): void {
      this.$emit("close", e);
    },
    onChange(value: string, type: string): void {
      if (type === "mail") this.mail = value;
      else if (type === "role") this.role = value;
      else if (type === "agence") this.agence = value;
      this.$emit("onFilterChange", { mail: this.mail, role: this.role, agence: this.agence });
    },
    cleanFilter(): void {
      this.mail = "";
      this.role = "";
      this.agence = "";
      this.$emit("onFilterChange", { mail: "", role: "", agence: "" });
    }
  }
});
